import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'

export const InputButtonWrapper = styled.div<{ hideExtraButtons?: boolean }>`
    display: grid;
    grid-template-columns: ${(props) => (props.hideExtraButtons ? '1fr' : '1fr 100px')};
    place-content: center;
    grid-gap: 5px;
    padding: 10px 10px 0 10px;
    position: relative;
    label {
        margin-top: 0px;
    }
    input {
        font-size: 14px;
        padding: 10px 5px;
    }

    & div {
        margin: 0;
    }
    .actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        display: none;
    }
`

export const IconWrapper = styled.div<{ floating?: boolean }>`
    display: grid;
    place-content: center;
    cursor: pointer;

    & div {
        border-radius: 100%;
        width: 50px;
        height: 50px;
        display: grid;
        place-content: center;
    }
    .send svg path {
        cursor: pointer;
        fill: ${({ floating }) => (floating ? theme.colors.white : theme.colors.deepSeaBlue)};
    }
    ${({ floating }) =>
        floating &&
        css`
            position: absolute;
            bottom: 10px;
            right: 10px;
        `}
`

export const HiddenInput = styled.input`
    display: none;
`
